// extracted by mini-css-extract-plugin
export default {"container":"DictionaryItemMeaning_container__HPYUi","capitalize":"DictionaryItemMeaning_capitalize__2BCQ2"};